import React from "react";
import DataPoint from "../Common/DataPoint";

class DasboardRow extends React.Component {
  getRedirectLinkType(displayType) {
    var count = 0;
    this.props.redirectLinks.map(function(redirectLink) {
      if (redirectLink.active === displayType) {
        count = count + 1;
      }
      return redirectLink;
    });
    return count;
  }
  render() {
    return (
      <div className="dashboard-row">
        <DataPoint
          data={this.props.redirectLinks.length}
          label={"Links"}
          positive={false}
        />
        <DataPoint
          data={this.getRedirectLinkType(true)}
          label={"Active"}
          positive={false}
        />
        <DataPoint
          data={this.getRedirectLinkType(false)}
          label={"Not Active"}
          positive={false}
        />
      </div>
    );
  }
}

export default DasboardRow;
